import request from '@/shared/api/request';

export const downloadBucketObject = (
  bucketName: string,
  objectKey: string,
): Promise<{ download_url: string }> =>
  request({
    url: `/buckets/${bucketName}/objects/${objectKey}/download/`,
    method: 'GET',
  });
